/* eslint-disable @typescript-eslint/no-unused-vars */
import { AddressCaptureOutageMapProps } from './types'
import AddressCaptureInput from '../shared/AddressCaptureInput'

const AddressOutageMap = (props: AddressCaptureOutageMapProps) => {
  const { id = '', theme = 'white', eyebrow = 'COX OUTAGE INFORMATION', inLayoutContainer = false } = props

  return (
    <div
      className={`react-ac-container ${inLayoutContainer ? '' : 'default-container-spacing'} ${theme}`}
      data-testid={`react-ac-container`}
    >
      <div>OUTAGE MAP</div>
      <div>{eyebrow}</div>
      {/* <AddressCaptureInput {...props} />  */}
    </div>
  )
}

export default AddressOutageMap
